export const investingCalculator = {
  pageTitle: "Investing calculator",
  eyebrow: "Plan & grow",
  subtitle:
    "Project how your investments could grow with compound returns and regular monthly contributions. For education only — not investment advice.",
  inputsHeading: "Your assumptions",
  initialLabel: "Initial investment",
  initialTooltip: "Lump sum you start with today.",
  monthlyLabel: "Monthly contribution",
  monthlyTooltip: "Amount you add at the end of each month.",
  rateLabel: "Expected annual return",
  rateSuffix: "% / year",
  rateTooltip: "Nominal annual return, compounded monthly (illustrative).",
  yearsLabel: "Time horizon",
  yearsSuffix: "years",
  yearsTooltip: "How long you stay invested.",
  calculate: "Calculate",
  reset: "Reset",
  outcomeHeadline: "In {{years}} years, you will have {{amount}}.",
  chartTitle: "Contributed vs portfolio value",
  chartPortfolio: "Portfolio value",
  chartContributed: "Contributed",
  chartYear: "Year",
  breakdownTitle: "Year-by-year breakdown",
  tableYear: "Year",
  tableContributed: "Total contributed",
  tablePortfolio: "Portfolio value",
  tableGrowth: "Growth",
  statFinal: "Ending balance",
  statContributed: "Total contributed",
  statInterest: "Investment growth",
  disclaimer:
    "This calculator is for general illustration only. It does not reflect taxes, fees, inflation, or market risk. Past performance does not guarantee future results. Akinda does not provide personalized investment advice.",
} as const;
